import React from 'react';
import { useCourse } from '../contexts/CourseContext';
import {
 Select,
 SelectContent,
 SelectItem,
 SelectTrigger,
 SelectValue,
} from './ui/select';

export function CourseSelector() {
 const { courses, selectedCourseId, setSelectedCourseId } = useCourse();

 if (courses.length <= 1) {
 return null;
 }

 return (
 <div className="px-4 py-3 border-b border-gray-200">
 <label className="block text-sm font-medium text-gray-700 mb-2">
 Select Course
 </label>
 <Select
 value={selectedCourseId || ''}
 onValueChange={setSelectedCourseId}
 >
 <SelectTrigger className="w-full">
 <SelectValue placeholder="Select a course" />
 </SelectTrigger>
 <SelectContent>
 {courses.map((course) => (
 <SelectItem key={course.id} value={course.id}>
 {course.name}
 </SelectItem>
 ))}
 </SelectContent>
 </Select>
 </div>
 );
}
